import Stack from "@mui/material/Stack";
import careersData from "../../data/pages/careers.json";
import { type MdaiCardProps, MdaiCard } from "../../components/MdaiCard";
import type { CareersPageTemplate } from "../../types/careersPageTemplate";

const cardStyle = {
  backgroundColor: "var(--mdai-darkest-purple)",
  minHeight: "100px",
};

const typedCareersData = careersData as CareersPageTemplate;

const openRolesArray: MdaiCardProps[] = typedCareersData.openRoles.map((role) => ({
  tag: role.tag,
  title: role.title,
  body: role.body,
  links: [
    role.detailsHref ? { label: "Details", href: role.detailsHref } : null,
    role.contactHref ? { label: "Contact", href: role.contactHref } : null,
  ].filter((link): link is { label: string; href: string } => link !== null),
  style: cardStyle,
  contentSpacing: 2,
}));

export const OpenRoles = () => {
  return (
    <Stack
      sx={{
        px: { sm: "24px", md: "72px" },
        pt: { sm: "24px", md: "60px" },
        pb: { sm: "60px", md: 0 },
      }}
      width={"100%"}
      rowGap={"14px"}
      position={"relative"}
      zIndex="2"
    >
      {openRolesArray.map((role) => (
        <MdaiCard card={role} key={role.title} />
      ))}
    </Stack>
  );
};
